// Named profiles supplied for the site. Do not add sample people.
// Photos are still missing for everyone except the founder.
export const TEAM = [
  {
    initials: "AV",
    name: "Anjaneya Varaprasad Mudigonda",
    role: "Founder & CEO",
    focus: "Founder of ZasyaOnline — leads company direction and the product portfolio.",
    tag: "25 years in contact centres",
    quote:
      "I didn't build MyBantu because AI became popular. I built it because after 25 years in this industry, I know how much easier customer communication can be.",
    bio: "Businesses should never lose a customer simply because they couldn't answer the phone. Anjaneya Varaprasad Mudigonda founded ZasyaOnline and leads its product portfolio — MoveOS, myBantu, LearnSphere and CraneSoftwares — and its consulting and delivery practice.",
    photo: "/assets/team/anjaneya-varaprasad-mudigonda.png",
    linkedin: "https://www.linkedin.com/in/zasya/",
    featured: true,
  },
  {
    initials: "GA",
    name: "Gautam Arcot",
    role: "Strategic Advisor",
    focus: "Strategic counsel on company direction and growth.",
    linkedin: "https://www.linkedin.com/in/gautam-arcot/",
  },
  {
    initials: "NP",
    name: "Nikhil Patil",
    role: "Head Engineering, CraneSoftwares",
    focus: "Engineering leadership for the CraneSoftwares platform.",
  },
  {
    initials: "NK",
    name: "Nikhil Khiyani",
    role: "Head Engineering, MoveOS",
    focus: "Engineering leadership for the MoveOS platform.",
  },
  {
    initials: "UM",
    name: "UshaSri Mudigonda",
    role: "Chief HR",
    focus: "People, hiring and organisational development.",
  },
  {
    initials: "VM",
    name: "Varaprasad Mudigonda",
    role: "Product Lead, myBantu",
    focus: "AI-powered call-centre product and industry workflows.",
  },
];
